import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Spinner } from "@/components/common";

// Public entry pages: a restored customer session goes straight to the dashboard.
export function GuestRoute({ children }) {
  const { user, reconnecting } = useAuth();
  if (user?.role === "CUSTOMER" || (reconnecting && user === null)) return <Navigate to="/dashboard" replace />;
  if (user === null) return <div className="min-h-screen bg-slate-50" data-testid="guest-route-checking"><Spinner label="Checking session" /></div>;
  return children;
}
